// @ts-nocheck
import { cartLineQuantityStyles, CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { productLineProps } from "@store/Themes/common/props/productLine";

Object.assign<CartLineQuantityStyles>(cartLineQuantityStyles, productLineProps.quantity || {});
